import { createAsyncThunk } from "@reduxjs/toolkit"
import axiosInstance from "services/axios"
import { AUTH } from "store/serverAPIRoute"


export const getOktaURL = createAsyncThunk(AUTH.OKTA_URL,
    async (params, { rejectWithValue }) => {
        try {
            const data = await axiosInstance.get(AUTH.OKTA_URL, { })
            return data.data
        } catch (e) {
            throw rejectWithValue(e)
        }
    }
)
